<template>
  <div>
	  <div class="page-bg">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
				
	  		<div class="task-guide-page">
				<div>
					<img src="../assets/task-guide-2026.jpg" alt="" />
				</div>
			</div>
			
			<i-nav></i-nav>
	  </div>
	  
 


  </div>
</template>

<script>


export default {

  data() {
    return {
		uid: null
        
       
    };
  },
  async mounted() {
	this.uid = window.localStorage.getItem('cscec2026UserId')
    if(!this.uid){
			this.$router.push({path:'/'})
			return
		}
	

  },
  methods: {
    
    
  },
};
</script>
<style  scoped lang="less">
	
	.task-guide-page{
		// padding-top: 28px;
		// position: absolute;
		// bottom: 170px;
		// width: 100%;
		// top: 146px;
		// overflow: hidden;
		// overflow-y: auto;
		img{
			display: block;
			width: 100%;
		}
	}
</style>

